export const NODE_TYPE_POPUPTIP = "popupTip";
export const POPUPTIP_ESCAPE_KEY = "Escape";
